import { BgGetStartedHeader } from 'assets/images'
import { breakpoints, colors } from 'style'
import styled from 'styled-components'

export const PricingPageContainer = styled.div`
  .hero-banner {
    position: relative;
    width: 100%;
    height: calc(100vw / 2.5);
    min-height: 300px;
    display: flex;
    flex-direction: column;
    background-image: url(${BgGetStartedHeader});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    color: white;
    .container {
      .get-header-content {
        padding-top: 50px;
        h1 {
          color: ${colors.dark8};
        }
      }
    }

    .cta-btn {
      background-color: ${colors.blueDark};
      border-radius: 300px;
      height: 400px;
      width: 400px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      justify-content: flex-start;
      position: absolute;
      left: 8.33%;
      bottom: 50px;

      :hover {
        color: ${colors.blueDark};
        background-color: ${colors.white};
        cursor: pointer;
      }

      .cta-title {
        font-size: 31px;
        margin-top: 51px;
      }

      .cta-money {
        font-weight: bold;
        font-size: 80px;
        margin-top: 25px;
      }

      p {
        width: 80%;
        margin-top: 42px;
      }

      @media (max-width: ${breakpoints.xl}px) {
        height: 300px;
        width: 300px;

        .cta-title {
          font-size: 24px;
          margin-top: 34px;
        }

        .cta-money {
          font-size: 55px;
          margin-top: 17px;
        }

        p {
          margin-top: 28px;
        }
      }

      @media (max-width: ${breakpoints.sm}px) {
        bottom: 10px;

        height: 250px;
        width: 250px;

        .cta-title {
          font-size: 21px;
          margin-top: 30px;
        }

        .cta-money {
          font-size: 55px;
          margin-top: 14px;
        }

        p {
          margin-top: 12px;
          font-size: 12px;
        }
      }
    }

    @media (max-width: ${breakpoints.sm}px) {
      /* height: 297px; */
      justify-content: flex-end;
      .container {
        .get-header-content {
          height: 100%;
          display: flex;
          align-items: flex-end;
          padding-bottom: 50px;
          h1 {
            color: ${colors.white};
          }
        }
      }
    }
  }
`
